let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dnBvs")).then(() => parcelRequire('abc2w'));